import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createBlock as _createBlock, TransitionGroup as _TransitionGroup, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, Teleport as _Teleport } from "vue"

import { computed } from 'vue';
import { useNotifications } from '@/composables/useNotifications';
import AppNotification from './AppNotification.vue';
import type { ToastNotification, ToastAction } from '@/types';

interface Props {
  position: 'top-right' | 'top-left' | 'bottom-right' | 'bottom-left' | 'top-center' | 'bottom-center';
  maxNotifications: number;
}

interface Emits {
  (e: 'action', action: ToastAction): void;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'NotificationContainer',
  props: {
    position: { default: 'top-right' },
    maxNotifications: { default: 5 }
  },
  emits: ["action"],
  setup(__props: any, { emit: __emit }) {

/// <reference types="vue" />
// @ts-ignore
const props = __props;

const emit = __emit;

const { notifications, removeNotification } = useNotifications();

// Classes CSS pour la position du conteneur
const containerClasses = computed(() => [
  `app-notifications-container--${props.position}`
]);

// Limiter le nombre de notifications affichées
const limitedNotifications = computed(() => {
  return notifications.value.slice(0, props.maxNotifications);
});

const handleAction = (action: ToastAction) => {
  emit('action', action);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createElementVNode("div", {
      class: _normalizeClass(["app-notifications-container", containerClasses.value])
    }, [
      _createVNode(_TransitionGroup, {
        name: "notification",
        tag: "div",
        class: "app-notifications-list"
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(limitedNotifications.value, (notification) => {
            return (_openBlock(), _createBlock(AppNotification, {
              key: notification.id,
              notification: notification,
              onClose: (notificationId) => _unref(removeNotification)(notificationId || notification.id),
              onAction: handleAction
            }, null, 8, ["notification", "onClose"]))
          }), 128))
        ]),
        _: 1
      })
    ], 2)
  ]))
}
}

})